export const FAQ_CATEGORIES = [
  {
    id: "general",
    letter: "A",
    label: "General",
    name: "About SimFinance",
    description: "The ecosystem, who it is for, and how to get started.",
    range: "01–20",
    icon: "compass",
  },
  {
    id: "simmarkets",
    letter: "B",
    label: "SimMarkets",
    name: "Marketplace",
    description: "Compare products, book appointments, and earn rewards.",
    range: "21–30",
    icon: "store",
  },
  {
    id: "simverify",
    letter: "C",
    label: "SimVerify",
    name: "Digital Trust",
    description: "Verification, fraud reduction, and AI Trust Scores.",
    range: "31–40",
    icon: "shield",
  },
  {
    id: "simcollect",
    letter: "D",
    label: "SimCollect",
    name: "Collections",
    description: "Recovery workflows, payments, and live reporting.",
    range: "41–50",
    icon: "wallet",
  },
  {
    id: "developers",
    letter: "E",
    label: "Developers",
    name: "APIs",
    description: "REST APIs, sandbox access, and integration security.",
    range: "51–55",
    icon: "code",
  },
  {
    id: "partnerships",
    letter: "F",
    label: "Partnerships",
    name: "Join the ecosystem",
    description: "Who can partner, benefits, and how to apply.",
    range: "56–60",
    icon: "handshake",
  },
  {
    id: "privacy",
    letter: "G",
    label: "Privacy",
    name: "Security",
    description: "Data protection, encryption, and incident reporting.",
    range: "61–65",
    icon: "lock",
  },
  {
    id: "account",
    letter: "H",
    label: "Account",
    name: "Billing & support",
    description: "Registration, passwords, fees, and customer support.",
    range: "66–70",
    icon: "user",
  },
];

export const FAQ_ITEMS = [
  {
    id: 1,
    n: "01",
    categoryId: "general",
    question: "What is SimFinance?",
    answer:
      "SimFinance is Africa's intelligent digital financial ecosystem that connects consumers, financial institutions and technology through one integrated platform. It combines SimMarkets (Marketplace), SimVerify (Digital Trust & Verification) and SimCollect (Debt Recovery & Collections) to simplify financial services and improve every stage of the financial customer journey.",
  },
  {
    id: 2,
    n: "02",
    categoryId: "general",
    question: "Is SimFinance a bank?",
    answer:
      "No. SimFinance is a financial technology company. We do not provide banking services directly. Instead, we connect consumers with verified financial institutions and provide technology solutions that improve customer acquisition, verification, lending and collections.",
  },
  {
    id: 3,
    n: "03",
    categoryId: "general",
    question: "What problems does SimFinance solve?",
    answer: "SimFinance helps solve several challenges including:",
    bullets: [
      "Difficulty finding trusted financial products",
      "Poor financial literacy",
      "Limited product comparison",
      "High customer acquisition costs",
      "Lending fraud",
      "Slow verification processes",
      "Poor debt recovery",
      "Low customer engagement",
    ],
  },
  {
    id: 4,
    n: "04",
    categoryId: "general",
    question: "Who can use SimFinance?",
    answer: "SimFinance is designed for:",
    bullets: [
      "Individuals",
      "Businesses",
      "Banks",
      "Insurance companies",
      "Savings & Loans companies",
      "Microfinance institutions",
      "FinTech companies",
      "Investment firms",
      "Pension providers",
      "Mortgage institutions",
    ],
  },
  {
    id: 5,
    n: "05",
    categoryId: "general",
    question: "What services does SimFinance provide?",
    answer: "The SimFinance ecosystem includes:",
    bullets: [
      "Financial Marketplace (SimMarkets)",
      "Digital Verification (SimVerify)",
      "Debt Recovery & Collections (SimCollect)",
    ],
  },
  {
    id: 6,
    n: "06",
    categoryId: "general",
    question: "Is SimFinance available across Africa?",
    answer:
      "SimFinance is designed to support Ghana initially, with a long-term vision of expanding across Africa.",
  },
  {
    id: 7,
    n: "07",
    categoryId: "general",
    question: "Why should I use SimFinance?",
    answer: "Because SimFinance helps you:",
    bullets: ["Learn", "Compare", "Decide", "Verify", "Connect", "Recover"],
    after: "through one intelligent ecosystem.",
  },
  {
    id: 8,
    n: "08",
    categoryId: "general",
    question: "Is registration free?",
    answer:
      "Yes. Consumers can browse educational content freely. Registration is required to access advanced services such as comparisons, AI recommendations and appointments.",
  },
  {
    id: 9,
    n: "09",
    categoryId: "general",
    question: "How secure is my information?",
    answer:
      "We implement strong security controls and comply with applicable data protection laws and industry best practices to safeguard customer information.",
  },
  {
    id: 10,
    n: "10",
    categoryId: "general",
    question: "Does SimFinance charge consumers?",
    answer:
      "Many educational resources and comparison services are available free of charge. Fees, if any, depend on specific partner services or premium offerings.",
  },
  {
    id: 11,
    n: "11",
    categoryId: "general",
    question: "How do I create an account?",
    answer:
      "Click Register, provide your basic details and verify your account to start using SimFinance services.",
  },
  {
    id: 12,
    n: "12",
    categoryId: "general",
    question: "Can businesses register?",
    answer:
      "Yes. Financial institutions, FinTech companies and service providers can register as institutional partners.",
  },
  {
    id: 13,
    n: "13",
    categoryId: "general",
    question: "How can I contact SimFinance?",
    answer: "You can reach us via:",
    bullets: ["Contact Form", "Email", "Telephone", "Live Chat", "WhatsApp", "Social Media"],
  },
  {
    id: 14,
    n: "14",
    categoryId: "general",
    question: "Does SimFinance provide financial advice?",
    answer:
      "SimFinance provides educational information and AI-assisted recommendations. Final financial decisions remain the responsibility of the customer.",
  },
  {
    id: 15,
    n: "15",
    categoryId: "general",
    question: "Can I access SimFinance on mobile?",
    answer: "Yes. SimFinance is designed to support web and mobile access.",
  },
  {
    id: 16,
    n: "16",
    categoryId: "general",
    question: "Which industries does SimFinance serve?",
    answer:
      "We support banking, insurance, investments, pensions, loans, mortgages, digital payments, SME finance and other financial services.",
  },
  {
    id: 17,
    n: "17",
    categoryId: "general",
    question: "Can I compare multiple financial products?",
    answer: "Yes. SimFinance allows side-by-side comparisons of products from verified providers.",
  },
  {
    id: 18,
    n: "18",
    categoryId: "general",
    question: "Does SimFinance work with verified institutions only?",
    answer:
      "Yes. Our goal is to connect consumers with trusted and verified financial service providers.",
  },
  {
    id: 19,
    n: "19",
    categoryId: "general",
    question: "Can I become a partner?",
    answer:
      "Absolutely. Financial institutions, technology providers and strategic organizations can join the SimFinance ecosystem.",
  },
  {
    id: 20,
    n: "20",
    categoryId: "general",
    question: "What makes SimFinance different?",
    answer:
      "Unlike traditional marketplaces, SimFinance integrates education, AI recommendations, verification, lead generation and debt recovery into one intelligent platform.",
  },
  {
    id: 21,
    n: "21",
    categoryId: "simmarkets",
    question: "What is SimMarket?",
    answer:
      "SimMarket is the intelligent financial marketplace within the SimFinance ecosystem that educates consumers, compares financial products, provides AI recommendations and connects customers with verified providers.",
  },
  {
    id: 22,
    n: "22",
    categoryId: "simmarkets",
    question: "What products can I compare?",
    answer: "Products include:",
    bullets: [
      "Insurance",
      "Loans",
      "Investments",
      "Pensions",
      "Banking Services",
      "Mortgages",
      "SME Finance",
      "Digital Payments",
    ],
  },
  {
    id: 23,
    n: "23",
    categoryId: "simmarkets",
    question: "How does the comparison engine work?",
    answer:
      "It compares multiple financial products side by side using important criteria such as pricing, benefits, interest rates, eligibility, features and terms.",
  },
  {
    id: 24,
    n: "24",
    categoryId: "simmarkets",
    question: "What is the AI Recommendation Engine?",
    answer:
      "It asks questions about your financial needs and recommends products that best match your requirements.",
  },
  {
    id: 25,
    n: "25",
    categoryId: "simmarkets",
    question: "Can I book appointments?",
    answer:
      "Yes. Customers can schedule consultations with verified financial institutions directly through the platform.",
  },
  {
    id: 26,
    n: "26",
    categoryId: "simmarkets",
    question: "What happens after I select a product?",
    answer:
      "Your information is securely shared with the selected provider for follow-up and service delivery.",
  },
  {
    id: 27,
    n: "27",
    categoryId: "simmarkets",
    question: "Can I browse without registering?",
    answer:
      "Yes. Registration becomes necessary when accessing advanced comparison and personalized recommendation features.",
  },
  {
    id: 28,
    n: "28",
    categoryId: "simmarkets",
    question: "What types of educational content are available?",
    answer: "You can access:",
    bullets: [
      "Articles",
      "Videos",
      "Blogs",
      "Podcasts",
      "Financial Tips",
      "Product Guides",
      "FAQs",
    ],
  },
  {
    id: 29,
    n: "29",
    categoryId: "simmarkets",
    question: "Can I earn rewards?",
    answer:
      "Yes. SimMarket includes a rewards and loyalty programme where eligible users may receive points, cashback or referral benefits.",
  },
  {
    id: 30,
    n: "30",
    categoryId: "simmarkets",
    question: "How do financial institutions benefit?",
    answer:
      "Institutions receive qualified, intent-driven customer leads that improve acquisition and conversion rates.",
  },
  {
    id: 31,
    n: "31",
    categoryId: "simverify",
    question: "What is SimVerify?",
    answer:
      "SimVerify is an AI-powered Digital Trust Intelligence Platform that helps organizations verify borrowers, vehicles, devices and behavioural data before approving financial transactions.",
  },
  {
    id: 32,
    n: "32",
    categoryId: "simverify",
    question: "Who uses SimVerify?",
    answer:
      "Banks, FinTech companies, insurers, lenders, vehicle financiers, retailers and other organizations.",
  },
  {
    id: 33,
    n: "33",
    categoryId: "simverify",
    question: "What can SimVerify verify?",
    answer: "It verifies:",
    bullets: ["Borrowers", "Vehicles", "Mobile Devices", "SIM Behaviour", "Asset Ownership"],
  },
  {
    id: 34,
    n: "34",
    categoryId: "simverify",
    question: "What is the AI Trust Score?",
    answer:
      "It is an intelligent score generated by combining multiple verification signals to support lending and risk decisions.",
  },
  {
    id: 35,
    n: "35",
    categoryId: "simverify",
    question: "How does SimVerify reduce fraud?",
    answer:
      "It identifies inconsistencies, fraudulent assets, stolen vehicles, financed devices and risky borrower behaviours before approval.",
  },
  {
    id: 36,
    n: "36",
    categoryId: "simverify",
    question: "Does SimVerify perform real-time verification?",
    answer:
      "Yes. The platform supports real-time API-based verification where connected data sources are available.",
  },
  {
    id: 37,
    n: "37",
    categoryId: "simverify",
    question: "Which industries benefit from SimVerify?",
    answer:
      "Banking, insurance, digital lending, vehicle finance, hire purchase, retail finance and telecommunications.",
  },
  {
    id: 38,
    n: "38",
    categoryId: "simverify",
    question: "Can SimVerify integrate with existing systems?",
    answer: "Yes. SimVerify is designed with secure APIs for enterprise integration.",
  },
  {
    id: 39,
    n: "39",
    categoryId: "simverify",
    question: "Does SimVerify replace credit bureaus?",
    answer:
      "No. It complements traditional credit information by adding asset verification, behavioural intelligence and AI-powered trust scoring.",
  },
  {
    id: 40,
    n: "40",
    categoryId: "simverify",
    question: "Is verification secure?",
    answer:
      "Yes. Security, audit trails and role-based access controls are integral parts of the platform architecture.",
  },
  {
    id: 41,
    n: "41",
    categoryId: "simcollect",
    question: "What is SimCollect?",
    answer:
      "SimCollect is an intelligent digital debt recovery and collection management platform that automates customer engagement, repayments and recovery workflows.",
  },
  {
    id: 42,
    n: "42",
    categoryId: "simcollect",
    question: "Who can use SimCollect?",
    answer:
      "Commercial banks, savings and loans companies, microfinance institutions, insurance companies, FinTech lenders and organizations managing receivables.",
  },
  {
    id: 43,
    n: "43",
    categoryId: "simcollect",
    question: "What types of debts can SimCollect manage?",
    answer:
      "The platform supports recovery for loans, insurance premiums, hire purchase agreements, educational loans and other receivables.",
  },
  {
    id: 44,
    n: "44",
    categoryId: "simcollect",
    question: "How does SimCollect improve recovery rates?",
    answer:
      "It automates reminders, communications, payment processing, follow-ups, case management and reporting.",
  },
  {
    id: 45,
    n: "45",
    categoryId: "simcollect",
    question: "Which communication channels are supported?",
    answer: "SimCollect supports:",
    bullets: ["SMS", "Email", "WhatsApp", "Contact Centre", "USSD", "Mobile Money"],
  },
  {
    id: 46,
    n: "46",
    categoryId: "simcollect",
    question: "Can customers make partial payments?",
    answer:
      "Yes. Customers can make full, partial, scheduled or instalment repayments through supported digital channels.",
  },
  {
    id: 47,
    n: "47",
    categoryId: "simcollect",
    question: "Does SimCollect integrate with payment systems?",
    answer:
      "Yes. The platform supports integration with Mobile Money, USSD, payment gateways and banking systems.",
  },
  {
    id: 48,
    n: "48",
    categoryId: "simcollect",
    question: "Can management monitor recovery performance?",
    answer:
      "Yes. Real-time dashboards provide visibility into recovery rates, portfolio ageing, collector productivity and operational performance.",
  },
  {
    id: 49,
    n: "49",
    categoryId: "simcollect",
    question: "Does SimCollect support compliance?",
    answer:
      "Yes. It maintains complete audit trails and supports operational reporting and regulatory compliance requirements.",
  },
  {
    id: 50,
    n: "50",
    categoryId: "simcollect",
    question: "How can my organization implement SimCollect?",
    answer:
      "Contact the SimFinance Business Development team to schedule a demonstration, discuss integration requirements and begin the onboarding process.",
  },
  {
    id: 51,
    n: "51",
    categoryId: "developers",
    question: "Does SimFinance provide APIs for integration?",
    answer:
      "Yes. SimFinance provides secure RESTful APIs that enable financial institutions, FinTech companies and technology partners to integrate with our ecosystem. Depending on the solution, APIs can support customer onboarding, verification services, lead management, payment processing and reporting.",
  },
  {
    id: 52,
    n: "52",
    categoryId: "developers",
    question: "Which SimFinance solutions support API integration?",
    answer: "Our solutions are designed with integration in mind, including:",
    bullets: [
      "SimMarkets – Customer lead generation and marketplace services",
      "SimVerify – Digital trust verification and AI-powered Trust Scores",
      "SimCollect – Debt portfolio management, payment reconciliation and collection workflows",
    ],
    after:
      "Our integration team works with partners to determine the most suitable APIs for their business needs.",
  },
  {
    id: 53,
    n: "53",
    categoryId: "developers",
    question: "How do developers gain access to the APIs?",
    answer:
      "Developers can register through the Developer Portal by creating an account and submitting an API access request. Once approved, they receive API credentials, documentation, authentication details and testing resources to begin integration.",
  },
  {
    id: 54,
    n: "54",
    categoryId: "developers",
    question: "Is there a sandbox environment for testing?",
    answer:
      "Yes. SimFinance plans to provide a secure sandbox environment where developers can safely test integrations before connecting to production systems. The sandbox mirrors core functionality without affecting live customer data.",
  },
  {
    id: 55,
    n: "55",
    categoryId: "developers",
    question: "What security measures protect API integrations?",
    answer: "Our APIs are designed with enterprise-grade security, including:",
    bullets: [
      "Secure authentication and authorization",
      "Encrypted data transmission",
      "Role-based access control",
      "Audit logging",
      "API monitoring and usage controls",
    ],
    after: "These measures help ensure secure and reliable integrations across the SimFinance ecosystem.",
  },
  {
    id: 56,
    n: "56",
    categoryId: "partnerships",
    question: "Who can become a SimFinance partner?",
    answer: "We welcome partnerships with organizations across the financial services ecosystem, including:",
    bullets: [
      "Commercial Banks",
      "Rural Banks",
      "Savings & Loans Companies",
      "Microfinance Institutions",
      "Insurance Companies",
      "Investment Firms",
      "Pension Providers",
      "FinTech Companies",
      "Digital Lenders",
      "Payment Service Providers",
      "Technology Companies",
    ],
  },
  {
    id: 57,
    n: "57",
    categoryId: "partnerships",
    question: "What benefits do partners receive?",
    answer: "Partners gain access to:",
    bullets: [
      "Qualified customer leads",
      "AI-powered customer matching",
      "Digital verification services",
      "Debt recovery solutions",
      "Business intelligence dashboards",
      "API integrations",
      "Marketing and visibility opportunities",
      "Dedicated onboarding and support",
    ],
  },
  {
    id: 58,
    n: "58",
    categoryId: "partnerships",
    question: "How do I apply to become a partner?",
    answer:
      "Simply complete the Partner Registration Form on our website or contact our Business Development team. After reviewing your application, we'll discuss your business objectives, integration requirements and onboarding process.",
  },
  {
    id: 59,
    n: "59",
    categoryId: "partnerships",
    question: "Does SimFinance support strategic technology partnerships?",
    answer:
      "Yes. We actively collaborate with technology providers, payment platforms, mobile network operators, data providers, cloud service providers and other organizations that strengthen our ecosystem and create additional value for customers.",
  },
  {
    id: 60,
    n: "60",
    categoryId: "partnerships",
    question: "Can partners customize their solutions?",
    answer:
      "Yes. Depending on the service, partners may be able to customize dashboards, products, workflows, reporting and integrations to align with their operational requirements and business processes.",
  },
  {
    id: 61,
    n: "61",
    categoryId: "privacy",
    question: "How does SimFinance protect my personal information?",
    answer:
      "Protecting customer information is one of our highest priorities. We use industry-standard security controls, secure infrastructure and strict access management to safeguard personal and business data throughout the SimFinance ecosystem.",
  },
  {
    id: 62,
    n: "62",
    categoryId: "privacy",
    question: "Does SimFinance comply with data protection regulations?",
    answer:
      "Yes. SimFinance is designed to comply with applicable data protection and privacy regulations, including the Ghana Data Protection Act, 2012 (Act 843), consumer protection laws and relevant electronic communication regulations.",
  },
  {
    id: 63,
    n: "63",
    categoryId: "privacy",
    question: "Will my information be shared with third parties?",
    answer:
      "Customer information is shared only where necessary to provide requested services and only with authorized and verified financial institutions or partners involved in delivering those services. We do not share customer information for unauthorized purposes.",
  },
  {
    id: 64,
    n: "64",
    categoryId: "privacy",
    question: "Is my information encrypted?",
    answer:
      "Yes. Sensitive information transmitted through the SimFinance platform is protected using modern encryption technologies and secure communication protocols to help maintain confidentiality and integrity.",
  },
  {
    id: 65,
    n: "65",
    categoryId: "privacy",
    question: "How can I report a security concern?",
    answer:
      "If you believe you have identified a security issue or suspicious activity, please contact our Security Team immediately using the contact details provided on our website. We investigate all reported security concerns promptly and responsibly.",
  },
  {
    id: 66,
    n: "66",
    categoryId: "account",
    question: "How do I create a SimFinance account?",
    answer:
      "Click Register on the website, complete the registration form with your basic information and verify your account to begin accessing SimFinance services.",
  },
  {
    id: 67,
    n: "67",
    categoryId: "account",
    question: "I forgot my password. What should I do?",
    answer:
      "Select Forgot Password on the login page and follow the instructions to securely reset your password. If you continue to experience difficulties, our support team will be happy to assist you.",
  },
  {
    id: 68,
    n: "68",
    categoryId: "account",
    question: "Can I update my account information?",
    answer:
      "Yes. After logging into your account, you can update your personal details, contact information, communication preferences and other profile settings through your account dashboard.",
  },
  {
    id: 69,
    n: "69",
    categoryId: "account",
    question: "Does SimFinance charge subscription fees?",
    answer:
      "Many of SimFinance's educational resources and marketplace services are available free of charge for consumers. Fees for institutional services, enterprise integrations or premium solutions depend on the selected products and partnership arrangements. Please contact our Sales Team for detailed pricing information.",
  },
  {
    id: 70,
    n: "70",
    categoryId: "account",
    question: "How do I contact Customer Support?",
    answer: "Our Customer Support team can be reached through several convenient channels, including:",
    bullets: ["Contact Form", "Email", "Telephone", "Live Chat", "WhatsApp", "Social Media"],
    after:
      "Our team is available to assist with account access, technical issues, partnership enquiries and general questions about the SimFinance ecosystem.",
  },
];

export const POPULAR_FAQ_IDS = [1, 2, 21, 31, 41, 51, 61, 66];

export const CATEGORY_BY_ID = Object.fromEntries(FAQ_CATEGORIES.map((item) => [item.id, item]));

export function faqHaystack(item) {
  const category = CATEGORY_BY_ID[item.categoryId];
  return [
    item.question,
    item.answer,
    ...(item.bullets || []),
    item.after || "",
    category?.label,
    category?.name,
  ]
    .join(" ")
    .toLowerCase();
}

export function matchesFaqQuery(item, query) {
  const tokens = query.trim().toLowerCase().split(/\s+/).filter(Boolean);
  if (!tokens.length) return true;
  const hay = faqHaystack(item);
  return tokens.every((token) => hay.includes(token));
}
